import Vue from 'vue';
import { mapGetters } from 'vuex';
import Invite from './invite';
import UserTable from './user-table';

export default Vue.component('storm-settings-users', {
  template: require('./template.html'),
  name: 'storm-settings-users',
  computed: {
    ...mapGetters(['stormUser']),
  },
  components: {
    Invite,
    UserTable,
  },
  data() {
    return {
      loading: false,
      view: 'table',
    };
  },
});



// WEBPACK FOOTER //
// ./src/storm/pages/settings-modal/storm-users/index.js